export default "/ressources/logged/img/icon/svg/adyen_legacy.svg";